import { Text, Flex } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';

import { getPlannerBlock } from 'redux/PlannerModeSlice';

import PlannerModeBlockSetting from './BlockSetting';
import PlannerModeScenario from './Scenario';
import PlannerModeScenarioForecast from './ScenarioForecast';

const PlannerModeHeader = ({ flags }: any) => {
  const plannerBlock = useSelector(getPlannerBlock);

  return (
    <>
      <Flex alignItems={'center'} justifyContent={'space-between'}>
        <Text variant={'heading'}>{plannerBlock?.name}</Text>
        <Flex alignItems={'center'} gap={2}>
          <PlannerModeBlockSetting />
          {flags?.blox977ActualVsForecastVisualization ? (
            <PlannerModeScenarioForecast />
          ) : (
            <PlannerModeScenario />
          )}
        </Flex>
      </Flex>
    </>
  );
};

export default withLDConsumer()(PlannerModeHeader);
